'use client';

import { c as _c } from "react/compiler-runtime";
import { BasicTooltip } from '@/comps/basic-tooltip';
import CircularPercentage from '@/comps/CircularPercentage';
import { AIFI_DATA_NUMBER_CLASS } from '@/domains/pages/ai-proficiency/typography';
import { MODEL_SAVINGS_POSITIVE_COLOR } from '@/domains/pages/model-savings/constants';
import { formatScore } from '@/utils/format.util';
import { cn } from '@/utils/shad';
import type { ReactNode } from 'react';
const SAVINGS_SHARE_RING_TOOLTIP = 'Share of this task’s current AI spend that could be saved by switching to the recommended model tier mix.';
type SavingsShareProgressProps = {
  value: number;
  size?: number;
  /** Overrides the default explanation shown on hover. */
  tooltip?: ReactNode;
};
export function SavingsShareProgress(t0) {
  const $ = _c(10);
  const {
    value,
    size: t1,
    tooltip
  } = t0;
  const size = t1 === undefined ? 16 : t1;
  const ringFill = Math.min(1, Math.max(0, value / 100));
  const t2 = tooltip ?? SAVINGS_SHARE_RING_TOOLTIP;
  const t3 = size / 2;
  let t4;
  if ($[0] !== value) {
    t4 = formatScore(value, {
      decimals: 0
    });
    $[0] = value;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = `${t4}%`;
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = cn("gap-1 text-[10px] text-muted-foreground", AIFI_DATA_NUMBER_CLASS);
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  let t7;
  if ($[3] !== ringFill || $[4] !== t3 || $[5] !== t5) {
    t7 = <span className="inline-flex items-center"><CircularPercentage percentage={ringFill} radius={t3} stroke={2} strokeColor={MODEL_SAVINGS_POSITIVE_COLOR} displayAsNumber={true} number={t5} className={t6} /></span>;
    $[3] = ringFill;
    $[4] = t3;
    $[5] = t5;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== t2 || $[8] !== t7) {
    t8 = <BasicTooltip text={t2} side="bottom" classNameContent="max-w-72 break-normal leading-relaxed">{t7}</BasicTooltip>;
    $[7] = t2;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  return t8;
}